import './index.css'

const NotFoundRoute = () => (
  <div className="notfound">
    <img
      src="https://assets.ccbp.in/frontend/react-js/nxt-watch-not-found-light-theme-img.png"
      alt="not found"
      className="notfounded"
    />
    <h1>Page Not Found</h1>
    <p>we are sorry, the page you requested could not be found.</p>
  </div>
)

export default NotFoundRoute
